import { chunkArray, } from "@polyratings/shared";
const WORKER_RETRIEVAL_CHUNK_SIZE = 1000;
export class AdminModule {
    constructor(httpModule) {
        this.httpModule = httpModule;
    }
    async bulkKvKeys(bulkKey) {
        const keyRequest = await this.httpModule.fetch(`/admin/bulk/${bulkKey}`);
        return keyRequest.json();
    }
    async bulkKvValues(bulkKey, keys) {
        const chunkedKeys = chunkArray(keys, WORKER_RETRIEVAL_CHUNK_SIZE);
        const results = await Promise.all(chunkedKeys.map((chunk) => this.httpModule.fetch(`/admin/bulk/${bulkKey}`, {
            method: "POST",
            body: JSON.stringify({
                keys: chunk,
            }),
        })));
        const bodies2d = await Promise.all(results.map((res) => res.json()));
        return bodies2d.flat();
    }
    async bulkKvRecord(bulkKey) {
        const keys = await this.bulkKvKeys(bulkKey);
        const values = await this.bulkKvValues(bulkKey, keys);
        return Object.fromEntries(keys.map((k, i) => [k, values[i]]));
    }
    async pendingProfessors() {
        const pendingProfessorsRes = await this.httpModule.fetch("/admin/professors/pending");
        return pendingProfessorsRes.json();
    }
    async approvePendingProfessor(professorId) {
        await this.httpModule.fetch(`/admin/pending/${professorId}`, {
            method: "POST",
        });
    }
    async removePendingProfessor(professorId) {
        await this.httpModule.fetch(`/admin/pending/${professorId}`, {
            method: "DELETE",
        });
    }
    async removeRating(professorId, reviewId) {
        await this.httpModule.fetch(`/admin/rating/${professorId}/${reviewId}`, {
            method: "DELETE",
        });
    }
    async approveReport(ratingId) {
        await this.httpModule.fetch(`/admin/reports/${ratingId}`, {
            method: "POST",
        });
    }
    async removeReport(ratingId) {
        await this.httpModule.fetch(`/admin/reports/${ratingId}`, {
            method: "DELETE",
        });
    }
    async deleteProfessor(id) {
        await this.httpModule.fetch(`/admin/professor/${id}`, { method: "DELETE" });
    }
    async mergeProfessor(mergeRequest) {
        await this.httpModule.fetch("/admin/professor/merge", {
            body: JSON.stringify(mergeRequest),
            method: "POST",
        });
    }
    async changeProfessorDepartment(departmentChangeRequest) {
        await this.httpModule.fetch("/admin/professor/department", {
            body: JSON.stringify(departmentChangeRequest),
            method: "POST",
        });
    }
}
//# sourceMappingURL=Admin.module.js.map